import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import promotion from '../../../../../promotion_config';

import Welcome from './welcome.js';

import mobile_promo_logo from './promo.png';
import scel_mob_logo from './mob_logo.png';

// Regarding page refresh... The onActive and refresh methods are for
// triggering and catching page refreshes in order to set the active element without
// re-rendering the whole dang page

const PrimaryNav = ({ user, actions, menuLinks }) => {
    return (
        <div id="nav-target" className="navigation">
            <nav>
                <ul>
                    <li className="visible-xs mobile-promo-header-logo">
                        <img
                            src={mobile_promo_logo}
                            alt={promotion.title}
                            className="img-responsive center-block"
                        />
                    </li>
                    {menuLinks.map((link, key) => {
                        const usePartial = link.uri !== '/';
                        return (
                            <li className="" key={`main-menu--${key}`}>
                                <Link
                                    to={link.uri}
                                    className=""
                                    partiallyActive={usePartial}
                                    activeClassName="active"
                                >
                                    {link.title}
                                </Link>
                            </li>
                        );
                    })}
                    <li className="welcome-links">
                        <Welcome user={user} actions={actions} />
                    </li>
                    <li className="secl-link visible-xs">
                        <a
                            href={promotion.lotteryUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={scel_mob_logo}
                                alt={promotion.lotteryName}
                                className="img-responsive center-block"
                            />
                        </a>
                    </li>
                </ul>
                <div className="menu-icon">
                    <div className="navbar-toggle icon">
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                        <span className="icon-bar"></span>
                    </div>
                </div>
            </nav>
        </div>
    );
};

PrimaryNav.propTypes = {
    menuLinks: PropTypes.arrayOf(
        PropTypes.shape({
            uri: PropTypes.string,
            title: PropTypes.string,
        })
    ),
};

export default PrimaryNav;
